/*
 * @fileOverView Footer Social component definition
 */

import Vue from 'vue';
import Analytics from 'mixins/analytics.mixin';

/**
 * Footer Social component
 *
 * @type {class}
 */
Vue.component('footer-social-vue', {
  mixins:[
    Analytics
  ],

  methods: {
    handleClick(service) {
      this.pushSocialSharedEvent(service, 'organization');
    }
  }
});
